var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2559",
    "data-name": "Group 2559",
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.979,
    height: 58.293,
    viewBox: "0 0 84.979 58.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M266.818,180.989c-1.841,0-5.314-.631-5.314-5.051V165.1h6.1v-5.314h-6.1v-.8a10.3,10.3,0,0,0-10.282-10.166h-3.6a10.208,10.208,0,0,0-4.715,1.154c-2.931,1.155-5.6,3.674-5.6,9.02v.79h-5.2a3.315,3.315,0,0,0-3.577,2.525l-4.578,13.417a32.514,32.514,0,0,0-.894,3.578h-.105a26.351,26.351,0,0,0-.947-3.578l-5.262-13.417a4.588,4.588,0,0,0-.953-1.64,3.323,3.323,0,0,0-2.572-.885h-6.966c-2.1,0-2.946,1.263-2.946,2.473v.683H203.2s-2.052-3.788-8.26-3.788c-7.734,0-11.891,6-11.891,13.363s4.367,13.574,12.048,13.574c3.578,0,5.893-1.21,7.471-3.473h.106s-.053.789-.053,1.42V185.3c0,4.841-3.525,6.577-7.576,6.577a17.322,17.322,0,0,1-7.418-1.789l-2.052,5.261a21.378,21.378,0,0,0,9.523,2.316c7,0,14.153-3.473,14.153-12.68V166.52a.969.969,0,0,1,.825-1.015c.429.082.7.318.932.91l8.944,20.151-.894,2.052c-.947,2.315-2.578,3.42-4.42,3.42A5.778,5.778,0,0,1,210.8,190.2l-2.578,4.736a9.93,9.93,0,0,0,6.787,2.736c4,0,7.787-2.157,9.681-7l9.629-24.255a1.341,1.341,0,0,1,1.526-.947h1.468v21.151h6.682V165.1h5.195v-5.314h-5.195v-.631c0-.137.021-.26.021-.389,0-5.445,2.467-9.09,6.429-9.182.054.014.194,0,.246.017,4.331.528,4.2,3.038,4.324,9.161.009.076.014.15.017.225h.011v.8h-4.17V165.1h4.013v11.68c0,9,7.359,10.1,11.095,10.1a12.313,12.313,0,0,0,2.052-.158v-5.84A6.143,6.143,0,0,1,266.818,180.989Zm-70.3-.526c-4.314,0-6.682-3.473-6.682-8.155,0-4.525,2.21-7.472,6.261-7.472,3.63,0,6.682,1.631,6.682,7.734C202.779,178.621,199.727,180.462,196.518,180.462Z",
    transform: "translate(-183.049 -139.374)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2556",
    "data-name": "Group 2556",
    transform: "translate(53.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2551",
    "data-name": "Group 2551",
    transform: "translate(14.119 8.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M381.384,152.041c-2.635-2.757-9.094-4.06-12.335-3.567l-.282-1.492c3.694-.8,11.017.069,13.1,3.124l-.875.3Z",
    transform: "translate(-368.767 -146.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M381.878,154.932A7.515,7.515,0,0,0,380.6,153.9a11.72,11.72,0,0,0-1.437-.8,17.988,17.988,0,0,0-3.1-1.1,21.614,21.614,0,0,0-3.232-.614c-.546-.06-1.094-.1-1.643-.106a10.521,10.521,0,0,0-1.644.083,12.845,12.845,0,0,1,3.292-.028,21.609,21.609,0,0,1,3.246.591,18.073,18.073,0,0,1,3.1,1.131A9.025,9.025,0,0,1,381.878,154.932Z",
    transform: "translate(-369.261 -149.591)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2552",
    "data-name": "Group 2552",
    transform: "translate(0 8.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M330.451,152.041c2.635-2.757,9.094-4.06,12.335-3.567l.282-1.492c-3.694-.8-11.017.069-13.1,3.124l.875.3Z",
    transform: "translate(-329.97 -146.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M331.293,154.932a7.533,7.533,0,0,1,1.282-1.029,11.708,11.708,0,0,1,1.438-.8,17.993,17.993,0,0,1,3.1-1.1,21.609,21.609,0,0,1,3.232-.614c.546-.06,1.094-.1,1.643-.106a10.527,10.527,0,0,1,1.644.083,12.846,12.846,0,0,0-3.292-.028,21.605,21.605,0,0,0-3.246.591,18.067,18.067,0,0,0-3.1,1.131A9.029,9.029,0,0,0,331.293,154.932Z",
    transform: "translate(-330.812 -149.591)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2555",
    "data-name": "Group 2555",
    transform: "translate(2.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2553",
    "data-name": "Group 2553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M349.363,134.985c-8.537.084-11.243-6.35-10.9-7.749l-.678,3.062c-.278,1.745,4.081,6.979,11.084,5.342Z",
    transform: "translate(-337.767 -125.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M337.778,135.65a1.769,1.769,0,0,0,.131.834,4.2,4.2,0,0,0,.383.759,7.151,7.151,0,0,0,1.075,1.316,9.428,9.428,0,0,0,2.818,1.879,9.946,9.946,0,0,0,3.289.819,10.816,10.816,0,0,0,1.7-.009,12,12,0,0,0,1.686-.255,12.014,12.014,0,0,1-1.683.286,10.793,10.793,0,0,1-1.709.02,10,10,0,0,1-3.312-.8,9.5,9.5,0,0,1-2.822-1.908,7.139,7.139,0,0,1-1.071-1.33,4.241,4.241,0,0,1-.372-.77A1.777,1.777,0,0,1,337.778,135.65Z",
    transform: "translate(-337.765 -130.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M349.431,132.168c-2.287-.673-3.22-1.376-5.383-6.594-1.8-4.355-5.206-2.487-5.568-1.122-.168.631-.678,3.062-.678,3.062.4-1.919,3.514-3.173,5.006.211,2.279,5.168,3.694,5.085,6.078,5.131Z",
    transform: "translate(-337.788 -122.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M337.8,132.292a2.438,2.438,0,0,1,1.1-1.541,2.381,2.381,0,0,1,1.875-.3,2.5,2.5,0,0,1,.87.434,3.385,3.385,0,0,1,.672.7,4.952,4.952,0,0,1,.486.844c.132.3.265.589.4.88a18.678,18.678,0,0,0,.907,1.709,7.644,7.644,0,0,0,1.175,1.528,3.844,3.844,0,0,0,.769.578,3.389,3.389,0,0,0,.9.344,9.76,9.76,0,0,0,1.926.166,9.716,9.716,0,0,1-1.933-.136,3.377,3.377,0,0,1-.909-.342,3.837,3.837,0,0,1-.78-.58,7.668,7.668,0,0,1-1.192-1.531,18.42,18.42,0,0,1-.919-1.71,10.806,10.806,0,0,0-.876-1.72,2.8,2.8,0,0,0-1.511-1.128A2.469,2.469,0,0,0,337.8,132.292Z",
    transform: "translate(-337.788 -127.637)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2554",
    "data-name": "Group 2554",
    transform: "translate(9.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M363.065,134.985c8.537.084,11.243-6.35,10.9-7.749l.678,3.062c.278,1.745-4.081,6.979-11.084,5.342Z",
    transform: "translate(-363.019 -125.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M375.519,135.65a1.773,1.773,0,0,1-.13.834,4.229,4.229,0,0,1-.383.759,7.15,7.15,0,0,1-1.075,1.316,9.431,9.431,0,0,1-2.818,1.879,9.948,9.948,0,0,1-3.289.819,10.806,10.806,0,0,1-1.7-.009,12,12,0,0,1-1.686-.255,12.016,12.016,0,0,0,1.683.286,10.793,10.793,0,0,0,1.709.02,10,10,0,0,0,3.312-.8,9.5,9.5,0,0,0,2.822-1.908,7.14,7.14,0,0,0,1.072-1.33,4.257,4.257,0,0,0,.371-.77A1.774,1.774,0,0,0,375.519,135.65Z",
    transform: "translate(-363.891 -130.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M362.94,132.168c2.287-.673,3.22-1.376,5.382-6.594,1.8-4.355,5.205-2.487,5.568-1.122.168.631.678,3.062.678,3.062-.4-1.919-3.514-3.173-5.006.211-2.279,5.168-3.694,5.085-6.078,5.131Z",
    transform: "translate(-362.94 -122.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M375.519,132.292a2.438,2.438,0,0,0-1.1-1.541,2.381,2.381,0,0,0-1.875-.3,2.493,2.493,0,0,0-.869.434,3.393,3.393,0,0,0-.673.7,4.974,4.974,0,0,0-.485.844c-.132.3-.265.589-.405.88a18.678,18.678,0,0,1-.907,1.709,7.622,7.622,0,0,1-1.176,1.528,3.832,3.832,0,0,1-.769.578,3.38,3.38,0,0,1-.9.344,9.76,9.76,0,0,1-1.926.166,9.714,9.714,0,0,0,1.933-.136,3.377,3.377,0,0,0,.909-.342,3.847,3.847,0,0,0,.78-.58,7.657,7.657,0,0,0,1.192-1.531,18.61,18.61,0,0,0,.919-1.71,10.811,10.811,0,0,1,.876-1.72,2.8,2.8,0,0,1,1.511-1.128A2.469,2.469,0,0,1,375.519,132.292Z",
    transform: "translate(-363.891 -127.637)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M361.752,143.946a1.541,1.541,0,0,1-.117,1.982c-.724.98,1.172.841,1.6.841s2.088.16,1.449-.863-.754-1.267-.319-1.651c.554-.49-.491-.181-1.214-.128C362.274,144.191,361.468,143.364,361.752,143.946Z",
    transform: "translate(-352.844 -136.139)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.6be70c82bf48dd81ae10abf508072d9f.svg";
export { ForwardRef as ReactComponent };